import React from 'react';
import '../styles/sidebar.css';

const PropertySidebar = ({ property, onClose, onAnalyze }) => {
  if (!property) return null;

  return (
    <div className="property-sidebar">
      <button className="close-btn" onClick={onClose}>×</button>
      
      <div className="sidebar-header">
        <h2>{property.address.line_1}</h2>
        <p className="address">{property.address.line_2}, {property.address.city}</p>
        <p className="postcode">{property.address.postcode}</p>
      </div>

      <div className="sidebar-content">
        <div className="price-section">
          <h3>{property.financials.asking_price != null ? `£${Number(property.financials.asking_price).toLocaleString()}` : '—'}</h3>
          {property.financials.gross_yield != null && (
            <span className="yield-badge">
              {Number(property.financials.gross_yield).toFixed(2)}% yield
            </span>
          )}
        </div>

        <div className="details-grid">
          <div className="detail-item">
            <label>Type</label>
            <value>{property.features.property_type}</value>
          </div>
          <div className="detail-item">
            <label>Bedrooms</label>
            <value>{property.features.bedrooms}</value>
          </div>
          <div className="detail-item">
            <label>Bathrooms</label>
            <value>{property.features.bathrooms}</value>
          </div>
          <div className="detail-item">
            <label>Tenure</label>
            <value>{property.features.tenure}</value>
          </div>
        </div>

        {property.financials.monthly_rent != null && (
          <div className="rent-section">
            <label>Estimated Monthly Rent</label>
            <value>£{Number(property.financials.monthly_rent).toLocaleString()}</value>
          </div>
        )}

        <div className="analysis-section">
          <h4>AI Analysis</h4>
          <p className="analysis-placeholder">
            Run comprehensive analysis including risk assessment, 
            Monte Carlo simulation, and investment strategy.
          </p>
          <button 
            className="analyze-btn"
            onClick={() => onAnalyze(property.id)}
          >
            Generate Investment Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertySidebar;
